<template>
    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
              <h3 class="box-title">Loan Emi Records</h3>
            </div>
            <div class="box-body no-padding">
              
              <table class="table table-sm table-bordered table-hover">
                <thead style="background-color: #d6dddd;">
                    <tr>
                    <th class="hidden-xs">Sr.</th>
                    <th>EMI Dt</th>
                    <th class="hidden-xs">Principal</th>
                    <th class="hidden-xs">Interest</th>
                    <th>EMI</th>
                    <th class="hidden-xs">Adjustment</th>
                    <th class="hidden-xs">Balance</th>
                    <th>Rec. Amt</th>
                    <th>Arrear</th>
                    <th class="hidden-xs">Advance</th>
                    <th class="hidden-xs">Status</th>
                    </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in singleLoanEmiRecord" :key="index">
                    <td class="hidden-xs">{{ (index + 1) }}</td>
                    <td>{{ row.emiDate | myDate }}</td>
                    <td class="hidden-xs">₹{{ row.principal }}/-</td>
                    <td class="hidden-xs">₹{{ row.intrest }}/-</td>
                    <td><strong>₹</strong>{{ row.total }}/-</td>
                    <td class="hidden-xs">{{ row.adjustment }}</td>
                    <td class="hidden-xs">{{ row.balance }}</td>
                    <td>{{ row.received }}</td>
                    <td>{{ row.arrear }}</td>
                    <td class="hidden-xs">{{ row.advance }}</td>
                    <td class="hidden-xs">
                        <span
                        v-if="row.status == 'pending'"
                        class="label label-warning xs"
                        >Pending</span>
                        <span
                        v-if="row.status == 'sattle'"
                        class="label label-primary xs"
                        >Settle</span>
                        <span
                        v-if="row.status == 'lock'"
                        class="label label-primary xs"
                        >Lock</span>
                        <span
                        v-if="row.status == 'sattlement'"
                        class="label label-warning xs"
                        >Settlement</span>
                        <span
                        v-if="row.status == 'paid'"
                        class="label label-success xs"
                        >Paid</span>
                        <span
                        v-if="row.status == 'partial'"
                        class="label label-info xs"
                        >Partial</span>                    
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
  
          </div>
        </div>
      </div>
    </section>
  </template>
  <script>
  export default {
    name: 'singleloanemirecords',
    props: {
      singleLoanBranchDetail: {},
      singleLoanMemberLoanPlan: {},
      singleLoanMemberDetail: {},
      singleLoanEmiRecord: {}
    }
  }
  </script>



// WEBPACK FOOTER //
// SingleLoanEmiRecords.vue?0d73ec5e